exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.leftpane {\r\n    background-color: #f8fff8;\n}\n.ontology-small {\r\n  border-top: 1px solid #c5c5c5;\r\n  color: #666666;\r\n  text-align: right;\r\n  margin: 10px 0 0;\r\n  padding: 10px;\r\n  color:#31b34a;\n}\n.ontology-small-title {\r\n  font-weight: bold;\r\n  color:#31b34a;\n}\ndiv.top-terms {\r\n  font-size: 11px;\r\n  font-weight: bold;\r\n  line-height: 12px;\n}\ndiv.top-term {\r\n  display: inline;\r\n  font-size: 11px;\r\n  margin: 0 5px;\r\n  font-weight: normal;\r\n  font-style: normal;\r\n  float: none;\n}\r\n\r\n\r\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"sourceMap":false}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-f19fb928","scoped":false,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/OntologiesLeftPane.vue
// module id = gZDP
// module chunks = 1